import { render, staticRenderFns } from "./AccountPasswordView.vue?vue&type=template&id=23deedea"
import script from "./AccountPasswordView.vue?vue&type=script&lang=js"
export * from "./AccountPasswordView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports